import "./footer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTelegram,
  faWhatsapp,
  faViber,
} from "@fortawesome/free-brands-svg-icons";
import { faPhone, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/logo.svg";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const districts = [
  "ვაკე",
  "საბურთალო",
  "გლდანი",
  "ისანი",
  "სამგორი",
  "დიდუბე",
  "ჩუღურეთი",
  "მთაწმინდა",
  "ნაძალადევი",
  "კრწანისი",
  "ავლაბარი",
  "ვარკეთილი",
];

const Footer = () => {
  const { lang = "ka" } = useParams();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col">
          <img className="footer-logo" src={logo} alt="Prime Clean logo" />
          <p className="footer-desc">{t("footer_desc")}</p>
          <div className="footer-socials">
            <a
              href="https://api.whatsapp.com/send?phone=+995557396727"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a
              href="https://t.me/+BFM2rxPtjTs0Njcy"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faTelegram} />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t("footer_links")}</h4>
          <ul className="footer-list">
            <li>
              <Link to={`/${lang}`}>{t("header1")}</Link>
            </li>
            <li>
              <Link to={`/${lang}/contact`}>{t("header3")}</Link>
            </li>
            <li>
              <Link to={`/${lang}/faq`}>{t("header4")}</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t("footer_districts")}</h4>
          <div className="footer-districts">
            {districts.map((d) => (
              <span key={d} className="district-tag">
                {d}
              </span>
            ))}
          </div>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">{t("footer_contact")}</h4>
          <ul className="footer-contact-list">
            <li>
              <a href="tel:+995557396727">
                <FontAwesomeIcon icon={faPhone} />
                +995 557 396 727
              </a>
            </li>
            <li>
              <FontAwesomeIcon icon={faLocationDot} />
              თბილისი, პეკინის ქ. 52
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 Prime Clean. {t("footer_rights")}</p>
      </div>
    </footer>
  );
};

export default Footer;
